import { Injectable } from "@angular/core";
import { Time } from "@models";
import { DesktopNotifyService } from "./desktop.notify.service";
import { Transaction } from "@models/transaction";

@Injectable({
	providedIn: "root"
})
export abstract class TransactionNotifyService<T extends Transaction> extends DesktopNotifyService<T> {
	protected NOTIFICATION_ID: string = "1";

	protected abstract LABEL: string;

	protected abstract caseNew(transaction: Transaction): string;

	protected send(action: string, transaction: Transaction): void {
		if (transaction.isIndex() && transaction.isSwap()) {
			return;
		}

		let text = ""; // Panda Transaction Alert 🐼
		let tag = "Bitpanda_transaction_" + action;
		const time = new Time();
		time.setByDate(new Date());

		if (!transaction || transaction.getIsBfc()) {
			return;
		}

		const status = transaction.getStatus() || "finished";

		// Generic attributes
		time.setByDate(transaction.getTime().date());

		tag = "Bitpanda_" + this.LABEL + "_transaction_" + action + "_" + status;

		// Specific attributes
		if (action === "new" && status === "finished") {
			text = this.caseNew(transaction);
		} else if (action === "cancel") {
			text = "success_canceled_" + this.LABEL + "_wallet_transaction";
		} else if (action === "update") {
			text = "info_text_transaction_updated";
		}

		if (text.length > 0) {
			this.desktopNotification("Bitpanda", {
				body: this.translationService.translate(text),
				tag: tag,
				time: time
			});
		}
	}
}
